// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ZQ-z","inlineTitle":"_Q-z","sponsoredAdsWrapper":"aR-z","marketplaceRecosWrapper":"bR-z"};